import Vue from 'vue'
import VueRouter from 'vue-router'

const home = () =>
    import ('@/views/home/index')

const product = () =>
    import ('@/views/product')
const ccWorry = () =>
    import ('@/views/product/ccWorry')
    // const ddosDefence = () =>
    //     import ('@/views/product/ddosDefence')
const xShield = () =>
    import ('@/views/product/xShield')
const xunDispense = () =>
    import ('@/views/product/xunDispense')
const sslCertificate = () =>
    import ('@/views/product/sslCertificate')
    // const woolShield = () =>
    //     import ('@/views/product/woolShield')
    // const baiControl = () =>
    //     import ('@/views/product/baiControl')
    // const xunPlatform = () =>
    //     import ('@/views/product/xunPlatform')


const complianceSupport = () =>
    import ('@/views/complianceSupport')

const customerService = () =>
    import ('@/views/customerService')


const solution = () =>
    import ('@/views/solution')
const gameSolution = () =>
    import ('@/views/solution/gameSolution')
const broadcastSolution = () =>
    import ('@/views/solution/broadcastSolution')
const shopSolution = () =>
    import ('@/views/solution/shopSolution')
const educationSolution = () =>
    import ('@/views/solution/educationSolution')
const newsSolution = () =>
    import ('@/views/solution/newsSolution')


const aboutUs = () =>
    import ('@/views/aboutUs/index')
const companyHonor = () =>
    import ('@/views/aboutUs/companyHonor')
const news = () =>
    import ('@/views/aboutUs/news')
const newsDetail = () =>
    import ('@/views/aboutUs/newsDetail')




const joinUs = () =>
    import ('@/views/joinUs')
const guide = () =>
    import ('@/views/guide/index')
const report = () =>
    import ('@/views/guide/children/report')


const server = () =>
    import ('@/views/intimateServer')
const equalInsurance2 = () =>
    import ('@/views/intimateServer/equalInsurance2')
const simulatedAttackAndDefense = () =>
    import ('@/views/intimateServer/simulatedAttackAndDefense')
const codeAudit = () =>
    import ('@/views/intimateServer/codeAudit')
const holeCheck = () =>
    import ('@/views/intimateServer/holeCheck')
const rescue = () =>
    import ('@/views/intimateServer/rescue')
const safetyVerification = () =>
    import ('@/views/intimateServer/safetyVerification')


const advice = () =>
    import ('@/views/advice')
const helpCenter = () =>
    import ('@/views/helpCenter')

const helpCenterDetail = () =>
    import ('@/views/helpCenterDetail')

const privacyAgreement = () =>
    import ('@/views/privacyAgreement')



Vue.use(VueRouter);

export default new VueRouter({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'home',
            component: home,
            meta: {
                showImg: true
            }
        },
        {
            path: '/product',
            name: 'product',
            component: product,
            meta: {
                showImg: true
            },
            children: [
                // {
                //     path: 'ddosDefence',
                //     name: 'ddosDefence',
                //     component: ddosDefence,
                //     meta: { showImg: true }
                // },
                {
                    path: 'ccWorry',
                    name: 'ccWorry',
                    component: ccWorry,
                    meta: {
                        showImg: true
                    }
                },
                {
                    path: 'xShield',
                    name: 'xShield',
                    component: xShield,
                    meta: {
                        showImg: true
                    }
                },
                {
                    path: 'xunDispense',
                    name: 'xunDispense',
                    component: xunDispense,
                    meta: {
                        showImg: true
                    }
                },
                {
                    path: 'sslCertificate',
                    name: 'sslCertificate',
                    component: sslCertificate,
                    meta: {
                        showImg: true
                    }
                },
                // {
                //     path: 'woolShield',
                //     name: 'woolShield',
                //     component: woolShield,
                //     meta: { showImg: true }
                // },
                // {
                //     path: 'baiControl',
                //     name: 'baiControl',
                //     component: baiControl,
                //     meta: { showImg: true }
                // },
                // {
                //     path: 'xunPlatform',
                //     name: 'xunPlatform',
                //     component: xunPlatform,
                //     meta: { showImg: true }
                // },
            ]
        },
        {
            path: '/solution',
            name: 'solution',
            component: solution,
            meta: {
                showImg: true
            },
            children: [{
                path: '/solution/gameSolution',
                name: 'gameSolution',
                meta: {
                    showImg: true
                },
                component: gameSolution
            }, {
                path: '/solution/broadcastSolution',
                name: 'broadcastSolution',
                meta: {
                    showImg: true
                },
                component: broadcastSolution
            }, {
                path: '/solution/shopSolution',
                name: 'shopSolution',
                meta: {
                    showImg: true
                },
                component: shopSolution
            }, {
                path: '/solution/educationSolution',
                name: 'educationSolution',
                meta: {
                    showImg: true
                },
                component: educationSolution
            }, {
                path: '/solution/newsSolution',
                name: 'newsSolution',
                meta: {
                    showImg: true
                },
                component: newsSolution
            }]
        },
        {
            path: '/intimateServer',
            name: 'intimateServer',
            component: server,
            meta: {
                showImg: true
            },
            children: [{
                    path: 'equalInsurance2',
                    name: 'equalInsurance2',
                    component: equalInsurance2,
                    meta: {
                        showImg: true
                    },
                },
                {
                    path: 'simulatedAttackAndDefense',
                    name: 'simulatedAttackAndDefense',
                    component: simulatedAttackAndDefense,
                    meta: {
                        showImg: true
                    },
                },
                {
                    path: 'codeAudit',
                    name: 'codeAudit',
                    component: codeAudit,
                    meta: {
                        showImg: true
                    },
                },
                {
                    path: 'holeCheck',
                    name: 'holeCheck',
                    component: holeCheck,
                    meta: {
                        showImg: true
                    },
                },
                {
                    path: 'rescue',
                    name: 'rescue',
                    component: rescue,
                    meta: {
                        showImg: true
                    },
                },
                {
                    path: 'safetyVerification',
                    name: 'safetyVerification',
                    component: safetyVerification,
                    meta: {
                        showImg: true
                    },
                },

            ]
        },
        {
            path: '/joinUs',
            name: 'joinUs',
            component: joinUs,
            meta: {
                showImg: false
            }
        },
        {
            path: '/complianceSupport',
            name: 'complianceSupport',
            component: complianceSupport,
            children: [],
            meta: {
                showImg: true
            }
        },
        {
            path: '/customerService',
            name: 'customerService',
            component: customerService,
            children: [],
            meta: {
                showImg: true
            }
        },
        {
            path: '/guide',
            name: 'guide',
            component: guide,
            meta: {
                showImg: true
            },
            children: [{
                path: '/guide/report',
                name: 'report',
                component: report,
                meta: {
                    showImg: true
                }
            }]
        },
        {
            path: '/aboutUs',
            name: 'aboutUs',
            component: aboutUs,
            meta: {
                showImg: true
            },
            children: [{
                path: '/aboutUs/companyHonor',
                name: 'companyHonor',
                component: companyHonor,
                meta: {
                    showImg: true
                }
            }, {
                path: 'news',
                name: 'news',
                component: news,
                meta: {
                    showImg: true
                },
                children: [{
                    path: 'newsDetail',
                    name: 'newsDetail',
                    component: newsDetail,
                    meta: {
                        showImg: false
                    }
                }]
            }, ]
        },
        {
            path: '/helpCenter',
            name: 'helpCenter',
            component: helpCenter,
            meta: {
                showImg: false
            }
            // children: [{
            //     path: 'helpCenterDetail',
            //     name: 'helpCenterDetail',
            //     component: helpCenterDetail
            // }]
        },
        {
            path: '/advice',
            name: 'advice',
            component: advice,
            meta: {
                showImg: false
            }
        },
        {
            path: '/helpCenter/helpCenterDetail',
            name: 'helpCenterDetail',
            component: helpCenterDetail,
            meta: {
                showImg: false
            }
        },
        {
            path: '/privacyAgreement',
            name: 'privacyAgreement',
            component: privacyAgreement,
            meta: {
                showImg: false
            }
        },
        {
            path: '/service',
            name: 'service',
            component: privacyAgreement,
            meta: {
                showImg: false
            }
        },

    ]
})